import AsyncStorage from '@react-native-async-storage/async-storage';

const CHAVE_MODIFICACAO_FUSO = 'ModificacaoFusoHorario';

interface DadosModificacaoFuso {
  fusoFuncionario: string;
  usuarioModificouFusoDispositivo: boolean;
}

export async function salvarFusoFuncionarioAsync(fusoFuncionario: string) {
  const dados: DadosModificacaoFuso = {
    fusoFuncionario,
    usuarioModificouFusoDispositivo: false
  };

  await AsyncStorage.setItem(CHAVE_MODIFICACAO_FUSO, JSON.stringify(dados));
}

export async function verificarFusoModificadoAsync(
  fusoMinutosFuncionario: number
): Promise<boolean> {
  const jsonDados = await AsyncStorage.getItem(CHAVE_MODIFICACAO_FUSO);

  if (jsonDados == null) {
    return false;
  }

  const dados: DadosModificacaoFuso = JSON.parse(jsonDados);

  if (dados.usuarioModificouFusoDispositivo) {
    return true;
  }

  const fusoDispositivo = (-new Date().getTimezoneOffset()).toString();

  if (fusoMinutosFuncionario.toString() !== fusoDispositivo) {
    dados.usuarioModificouFusoDispositivo = true;

    await AsyncStorage.setItem(CHAVE_MODIFICACAO_FUSO, JSON.stringify(dados));

    return true;
  }

  return false;
}
